import { render, staticRenderFns } from "./ListAlbumsIcons.vue?vue&type=template&id=98b5ecd6&"
import script from "./ListAlbumsIcons.vue?vue&type=script&lang=js&"
export * from "./ListAlbumsIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports